"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applySupplierAfterSalesApi = applySupplierAfterSalesApi;
exports.cancelSupplierAfterSalesApi = cancelSupplierAfterSalesApi;
exports.companyGetListApi = companyGetListApi;
exports.getLogisticsInfoApi = getLogisticsInfoApi;
exports.getOrderDivisionDetailsApi = getOrderDivisionDetailsApi;
exports.getOrderDivisionItemLedgerApi = getOrderDivisionItemLedgerApi;
exports.getOrderDivisionRecordApi = getOrderDivisionRecordApi;
exports.getOrderDivisionRecordsApi = getOrderDivisionRecordsApi;
exports.getOrderStatisticsListApi = getOrderStatisticsListApi;
exports.getOrderStatusListApi = getOrderStatusListApi;
exports.getParentOrderDivisionHistoryApi = getParentOrderDivisionHistoryApi;
exports.getRefundOrderLogisticsInfoApi = getRefundOrderLogisticsInfoApi;
exports.getRiskOrderDetailsApi = getRiskOrderDetailsApi;
exports.getRiskOrderListApi = getRiskOrderListApi;
exports.getSupplierAfterSalesDetailApi = getSupplierAfterSalesDetailApi;
exports.getSupplierOrderListApi = getSupplierOrderListApi;
exports.getSupplierReturnAddressApi = getSupplierReturnAddressApi;
exports.handleRiskOrderReviewApi = handleRiskOrderReviewApi;
exports.orderDeleteApi = orderDeleteApi;
exports.orderDetailApi = orderDetailApi;
exports.orderExcelApi = orderExcelApi;
exports.orderInvoiceListApi = orderInvoiceListApi;
exports.orderListApi = orderListApi;
exports.orderListDataApi = orderListDataApi;
exports.orderLogApi = orderLogApi;
exports.orderMarkApi = orderMarkApi;
exports.orderOfflineRefundCompleteApi = orderOfflineRefundCompleteApi;
exports.orderPrint = orderPrint;
exports.orderRefundApi = orderRefundApi;
exports.orderRefundCompulsoryApi = orderRefundCompulsoryApi;
exports.orderRefuseApi = orderRefuseApi;
exports.orderSendApi = orderSendApi;
exports.orderStatisticsApi = orderStatisticsApi;
exports.orderStatisticsExcelApi = orderStatisticsExcelApi;
exports.orderStatusNumApi = orderStatusNumApi;
exports.orderTimeApi = orderTimeApi;
exports.orderUpdateApi = orderUpdateApi;
exports.queryOrderDivisionApi = queryOrderDivisionApi;
exports.querySupplierOrderStatusApi = querySupplierOrderStatusApi;
exports.recordAdvanceRecoveryApi = recordAdvanceRecoveryApi;
exports.recordChannelReturnApi = recordChannelReturnApi;
exports.refundListApi = refundListApi;
exports.refundMarkApi = refundMarkApi;
exports.refundOrderDetailApi = refundOrderDetailApi;
exports.refundStatusNumApi = refundStatusNumApi;
exports.retryOrderDivisionApi = retryOrderDivisionApi;
exports.riskOrderExportExcelApi = riskOrderExportExcelApi;
exports.sheetInfoApi = sheetInfoApi;
exports.statisticsDataApi = statisticsDataApi;
exports.submitSupplierOrderApi = submitSupplierOrderApi;
exports.supplierAfterSalesDeliveryApi = supplierAfterSalesDeliveryApi;
exports.updatePriceApi = updatePriceApi;
exports.videoSendApi = videoSendApi;
exports.writeConfirmApi = writeConfirmApi;
exports.writeUpdateApi = writeUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 订单 列表
 * @param prams
 */
function orderListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/order/list',
    method: 'get',
    params: params
  });
}

/**
 * 订单 列表 获取各状态数量
 * @param params
 */
function orderStatusNumApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/order/status/num',
    method: 'get',
    params: params
  });
}

/**
 * 订单 列表 数据统计
 * @param params
 */
function orderListDataApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/list/data',
    method: 'get',
    params: params
  });
}
/**
 * 订单 删除
 * @param params
 */
function orderDeleteApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/delete',
    method: 'get',
    params: params
  });
}

/**
 * 订单 编辑
 * @param prams
 */
function orderUpdateApi(data, params) {
  return (0, _request.default)({
    url: '/admin/store/order/update',
    method: 'post',
    data: data,
    params: params
  });
}

/**
 * 订单 记录
 * @param prams
 */
function orderLogApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/status/list',
    method: 'get',
    params: params
  });
}

/**
 * 订单 详情
 * @param prams
 */
function orderDetailApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/order/info',
    method: 'get',
    params: params
  });
}
function getOrderDivisionRecordApi(orderNo) {
  return (0, _request.default)({
    url: '/admin/platform/pay/division/order/by-order-no',
    method: 'get',
    params: {
      orderNo: orderNo
    }
  });
}
function getOrderDivisionRecordsApi(orderNo) {
  return (0, _request.default)({
    url: '/admin/platform/pay/division/order/by-order-no/list',
    method: 'get',
    params: {
      orderNo: orderNo
    }
  });
}
function getParentOrderDivisionHistoryApi(orderNo) {
  return (0, _request.default)({
    url: '/admin/platform/pay/division/order/parent-history',
    method: 'get',
    params: {
      orderNo: orderNo
    }
  });
}
function getOrderDivisionDetailsApi(divisionOrderId) {
  return (0, _request.default)({
    url: '/admin/platform/pay/division/order/details',
    method: 'get',
    params: {
      divisionOrderId: divisionOrderId
    }
  });
}
function getOrderDivisionItemLedgerApi(orderNo) {
  return (0, _request.default)({
    url: '/admin/platform/pay/division/order/item-ledger',
    method: 'get',
    params: {
      orderNo: orderNo
    }
  });
}
function recordChannelReturnApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/pay/division/refund/channel-reconcile',
    method: 'post',
    data: data
  });
}
function recordAdvanceRecoveryApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/pay/division/refund/advance-recovery',
    method: 'post',
    data: data
  });
}
function retryOrderDivisionApi(divisionOrderId) {
  return (0, _request.default)({
    url: '/admin/platform/pay/division/order/retry',
    method: 'post',
    params: {
      divisionOrderId: divisionOrderId
    }
  });
}
function queryOrderDivisionApi(divisionOrderId) {
  return (0, _request.default)({
    url: '/admin/platform/pay/division/order/query',
    method: 'post',
    params: {
      divisionOrderId: divisionOrderId
    }
  });
}

/**
 * 订单 备注
 * @param prams
 */
function orderMarkApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/mark',
    method: 'post',
    params: params
  });
}

/**
 * 订单 发货
 * @param prams
 */
function orderSendApi(data) {
  return (0, _request.default)({
    url: '/admin/store/order/send',
    method: 'post',
    data: data
  });
}

/**
 * 订单 拒绝退款
 * @param prams
 */
function orderRefuseApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/refund/refuse',
    method: 'get',
    params: params
  });
}

/**
 * 订单 立即退款
 * @param prams
 */
function orderRefundApi(params) {
  return (0, _request.default)({
    url: '/admin/store/order/refund',
    method: 'get',
    params: params
  });
}

/**
 * 订单 核销订单
 * @param prams
 */
function writeUpdateApi(vCode) {
  return (0, _request.default)({
    url: "/admin/store/order/writeUpdate/".concat(vCode),
    method: 'get'
  });
}

/**
 * 订单 核销码查询待核销订单
 * @param prams
 */
function writeConfirmApi(vCode) {
  return (0, _request.default)({
    url: "/admin/store/order/writeConfirm/".concat(vCode),
    method: 'get'
  });
}

/**
 * 订单 统计 头部数据
 */
function orderStatisticsApi() {
  return (0, _request.default)({
    url: "/admin/store/order/statistics",
    method: 'get'
  });
}

/**
 * 核销订单 月列表数据
 */
function statisticsDataApi(params) {
  return (0, _request.default)({
    url: "/admin/store/order/statisticsData",
    method: 'get',
    params: params
  });
}

/**
 * 一键改价
 */
function updatePriceApi(data) {
  return (0, _request.default)({
    url: "admin/store/order/update/price",
    method: 'post',
    data: data
  });
}

/**
 *订单统计详情
 */
function orderTimeApi(params) {
  return (0, _request.default)({
    url: "/admin/store/order/time",
    method: 'get',
    params: params
  });
}

/**
 *面单默认配置信息
 */
function sheetInfoApi() {
  return (0, _request.default)({
    url: "/admin/store/order/sheet/info",
    method: 'get'
  });
}

/**
 *视频号物流公司
 */
function companyGetListApi() {
  return (0, _request.default)({
    url: "/admin/pay/component/delivery/company/get/list",
    method: 'get'
  });
}

/**
 *视频号物流公司
 */
function videoSendApi(data) {
  return (0, _request.default)({
    url: "/admin/store/order/video/send",
    method: 'post',
    data: data
  });
}

/**
 *打印小票
 */
function orderPrint(id) {
  return (0, _request.default)({
    url: "/admin/yly/print/".concat(id),
    method: 'get'
  });
}

/**
 *退款列表
 */
function refundListApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/refund/order/list",
    method: 'get',
    params: params
  });
}

/**
 *平台备注退款订单
 */
function refundMarkApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/refund/order/mark",
    method: 'post',
    data: data
  });
}

/**
 *获取退款订单各状态数量
 */
function refundStatusNumApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/refund/order/status/num",
    method: 'GET',
    params: params
  });
}

/**
 * 获取订单发货单列表
 * @param orderNo 订单号
 */
function orderInvoiceListApi(orderNo) {
  return (0, _request.default)({
    url: "/admin/platform/order/".concat(orderNo, "/invoice/list"),
    method: 'get'
  });
}

/**
 *平台端订单物流详情
 */
function getLogisticsInfoApi(invoiceId) {
  return (0, _request.default)({
    url: "/admin/platform/order/get/".concat(invoiceId, "/logistics/info"),
    method: 'get'
  });
}

/**
 * 平台端退款订单详情
 * @param refundOrderNo 订单号
 */
function refundOrderDetailApi(refundOrderNo) {
  return (0, _request.default)({
    url: "/admin/platform/refund/order/detail/".concat(refundOrderNo),
    method: 'get'
  });
}

/**
 * 平台端退款单物流详情
 */
function getRefundOrderLogisticsInfoApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/order/get/refundOrder/logistics/info",
    method: 'post',
    data: data
  });
}

/**
 * 平台端导出订单Excel
 * @param params 对象
 */
function orderExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/export/order/excel",
    method: 'get',
    params: params
  });
}

/**
 * 平台强制退款
 * @param refundOrderNo
 * @returns {*}
 */
function orderRefundCompulsoryApi(refundOrderNo) {
  return (0, _request.default)({
    url: "/admin/platform/refund/order/compulsory/refund/".concat(refundOrderNo),
    method: 'post'
  });
}

/**
 * 平台确认已线下退款
 */
function orderOfflineRefundCompleteApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/refund/order/offline/refund/complete",
    method: 'post',
    data: data
  });
}

/**
 * 订单详情-查询订单操作记录
 */
function getOrderStatusListApi(orderNo) {
  return (0, _request.default)({
    url: "/admin/platform/order/".concat(orderNo, "/status/list"),
    method: 'get'
  });
}

// ========== 订单-订单统计 ==========
/**
 * 获取订单统计列表
 */
function getOrderStatisticsListApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/order-statistics/list",
    method: 'get',
    params: params
  });
}

/**
 * 导出平台端订单统计Excel
 */
function orderStatisticsExcelApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/order-statistics/export",
    method: 'get',
    params: params
  });
}

// ========== 订单-风险订单 ==========
/**
 * 获取风险订单审核列表
 */
function getRiskOrderListApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/risk/order/getRiskOrderListPage",
    method: 'post',
    data: data
  });
}

/**
 * 风险订单-审核/批量审核
 */
function handleRiskOrderReviewApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/risk/order/handleRiskOrderReview",
    method: 'post',
    data: data
  });
}

/**
 * 获取风险订单详情-预警详情
 */
function getRiskOrderDetailsApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/risk/order/getRiskOrderDetails",
    method: 'get',
    params: params
  });
}

/**
 * 风险订单-导出Excel
 */
function riskOrderExportExcelApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/risk/order/exportExcel",
    method: 'post',
    data: data
  });
}
function getSupplierOrderListApi(orderNo) {
  return (0, _request.default)({
    url: '/supplier/order/list-by-order-no',
    method: 'get',
    params: {
      orderNo: orderNo
    }
  });
}
function submitSupplierOrderApi(orderNo) {
  return (0, _request.default)({
    url: '/supplier/order/submit',
    method: 'post',
    data: {
      orderNo: orderNo
    }
  });
}
function querySupplierOrderStatusApi(orderNo) {
  return (0, _request.default)({
    url: '/supplier/order/query-status',
    method: 'post',
    data: {
      orderNo: orderNo
    }
  });
}
function applySupplierAfterSalesApi(data) {
  var payload = typeof data === 'string' ? {
    orderNo: data
  } : data;
  return (0, _request.default)({
    url: '/supplier/order/apply-after-sales',
    method: 'post',
    data: payload
  });
}
function getSupplierAfterSalesDetailApi(data) {
  var payload = typeof data === 'string' ? {
    orderNo: data
  } : data;
  return (0, _request.default)({
    url: '/supplier/order/after-sales-detail',
    method: 'post',
    data: payload
  });
}
function cancelSupplierAfterSalesApi(orderNo) {
  return (0, _request.default)({
    url: '/supplier/order/cancel-after-sales',
    method: 'post',
    data: {
      orderNo: orderNo
    }
  });
}
function getSupplierReturnAddressApi(orderNo) {
  return (0, _request.default)({
    url: '/supplier/order/get-return-address',
    method: 'post',
    data: {
      orderNo: orderNo
    }
  });
}
function supplierAfterSalesDeliveryApi(data) {
  return (0, _request.default)({
    url: '/supplier/order/after-sales-delivery',
    method: 'post',
    data: data
  });
}